// components/SEO.tsx
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  keywords?: string;
  url?: string;
  type?: string;
  image?: string;
}

export const AppSeo: React.FC<SEOProps> = ({
  title,
  keywords,
  url,
  image,
  type = 'website'
}) => {
  const publicUrl = process.env.PUBLIC_URL || 'https://oldvineregistry.org';
  const siteTitle = 'Old Vines Registry'; // Your site name
  const fullTitle = `${title} | ${siteTitle}`;
  const fullUrl = url || window.location.href;
  const pageKeywords = keywords || "old vines, old vineyard, historic vineyards, vine registry, old vine database";
  const description = "A crowd-sourced database of old vine vineyards around the world.";
  const pageImage = image || publicUrl + "/twitter_card_image.jpg" 

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={pageKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};